var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop } from 'vue-property-decorator';
import { RadioButton } from './RadioButton';
let RadioImageButton = class RadioImageButton extends RadioButton {
};
__decorate([
    Prop({ type: Array, required: true })
], RadioImageButton.prototype, "choices", void 0);
RadioImageButton = __decorate([
    Component
], RadioImageButton);
export default RadioImageButton;
